module.exports = __webpack_public_path__ + "static/img/A33.2c51769f.jpg";